import {
    DeliveryServiceType,
} from 'app/enums/label.enums'
import {
    TypeIcon,
} from 'app/shared-components/NotificationIcon/notificationIcon.types'
import {
    WithId,
} from 'app/types/common.types'
import {
    FieldInCard, NestedField,
} from 'app/types/form.types'

import TooltipContentDeliveryService
    from '../AccountLaneTooltipContent/TooltipContentDeliveryService'

import {
    AccountLaneFormFields,
} from '../AccountLaneForm.fields'
import getTransportModeFields from './transportMode.fields'

export default ({
    getAllowedValues,
    isDeliveryRoad,
    handoverPointCountry,
    disabled,
    showLTL,
    showFTL,
    isStatusPriced,
}: {
    getAllowedValues: (val: Record<string, string>) => Record<string, string>,
    isDeliveryRoad: boolean,
    handoverPointCountry?: WithId<number>,
    disabled?: boolean,
    showFTL?: boolean,
    showLTL?: boolean,
    isStatusPriced?: boolean,
}): FieldInCard<keyof AccountLaneFormFields>[] => {
    return [
        {
            id: 'column1',
            fields: [
                {
                    name: 'deliveryServiceType',
                    componentName: 'EnumSelector',
                    allowedValues: getAllowedValues(DeliveryServiceType),
                    labelKey: 'AccountLane.deliveryServiceType',
                    notificationIconProps: {
                        content: TooltipContentDeliveryService,
                        type: TypeIcon.INFO,
                    },
                    required: true,
                    useDropdown: true,
                    disabled: disabled || isStatusPriced,
                },
                ...(isDeliveryRoad
                    ? getTransportModeFields({
                        getAllowedValues,
                        disabled,
                        showFTL,
                        showLTL,
                        isStatusPriced,
                    })
                    : []) as NestedField<keyof AccountLaneFormFields>[],
            ],
        },
        {
            id: 'column2',
            fields: [
                ...(isDeliveryRoad ? [
                    {
                        name: 'handoverPointCountry',
                        componentName: 'CountryDataSelector',
                        labelKey: 'AccountLane.handoverPointCountry',
                        required: true,
                        disabled: disabled || isStatusPriced,
                    },
                    {
                        name: 'handoverPointZipCode',
                        componentName: 'ZipCodeInput',
                        labelKey: 'AccountLane.handoverPointZipCode',
                        required: true,
                        country: handoverPointCountry,
                        disabled: disabled || isStatusPriced,
                    },
                    {
                        name: 'handoverPointAddress',
                        componentName: 'InputSingleline',
                        labelKey: 'AccountLane.handoverPointAddress',
                        disabled,
                    },
                ] as NestedField<keyof AccountLaneFormFields>[] : []),
                {
                    name: 'handoverPointContacts',
                    componentName: 'MultipleContactObjectSelector',
                    labelKey: 'AccountLane.handoverPointContacts',
                    disabled,
                },
            ],
        },
    ]
}
